import React, { FC } from 'react';
import FirstStep from './FirstStep';

const FirstStepsContainer: FC = () => {
  return (
    <div className='w-full mt-6 lg:mt-8 lg:flex'>
      <FirstStep
        number={1}
        iconPath='/images/how_it_works/glyph_step_film.png'
        title='Film your service'
      />
      <FirstStep
        number={2}
        iconPath='/images/how_it_works/glyph_step_upload.png'
        title='Upload to your streaming provider'
      />
      <FirstStep
        number={3}
        iconPath='/images/how_it_works/glyph_step_schedule.png'
        title='Set up your online service'
      />
      <FirstStep
        number={4}
        iconPath='/images/how_it_works/glyph_step_engage.png'
        title='Engage with attenders'
      />
      <FirstStep
        number={5}
        iconPath='/images/how_it_works/glyph_step_measure.png'
        title='Measure your impact'
      />
    </div>
  );
};

export default FirstStepsContainer;
